module.exports = __webpack_public_path__ + "static/media/25b.6eeb085a.jpg";